
export const ACTIONS = {
  SET_ECOMMERCE: 'ecommerce/SET_ECOMMERCE',
  CLEAR_ECOMMERCE: 'ecommerce/CLEAR_ECOMMERCE',
}

export default ACTIONS;
